import { useState, useEffect } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { Loader2, Sparkles, Moon } from "lucide-react";
import axios from "axios";
import StarCanvas from "@/components/StarCanvas";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const [status, setStatus] = useState("verifying");
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (!token) {
      setStatus("error");
      setMessage("Missing verification token.");
      return;
    }
    axios.post(`${API}/auth/verify-email`, { token })
      .then((res) => { setStatus("success"); setMessage(res.data.message); })
      .catch((err) => {
        setStatus("error");
        setMessage(err.response?.data?.detail || "Verification failed. The link may have expired.");
      });
  }, [token]);

  return (
    <div data-testid="verify-email-page" className="min-h-screen flex items-center justify-center bg-[#0B091A] px-4">
      <StarCanvas />
      <div className="relative z-10 glass-card rounded-3xl p-12 max-w-md w-full text-center">
        {status === "verifying" && (
          <>
            <Loader2 size={40} className="animate-spin text-amber-400 mx-auto mb-6" />
            <h2 className="font-serif text-2xl font-bold text-white">Verifying your email...</h2>
          </>
        )}
        {status === "success" && (
          <div data-testid="verify-success">
            <div className="w-20 h-20 rounded-full bg-amber-500/20 border-2 border-amber-400/40 flex items-center justify-center mx-auto mb-6">
              <Sparkles size={32} className="text-amber-400" />
            </div>
            <h2 className="font-serif text-2xl font-bold text-white mb-2">Email verified!</h2>
            <p className="text-slate-400 text-sm mb-8">{message} Your story library is now truly yours.</p>
            <Link
              to="/#generator"
              className="inline-block px-8 py-3 rounded-full bg-gradient-to-r from-purple-600 to-amber-500 text-white font-semibold text-sm hover:shadow-xl hover:shadow-purple-500/30 transition-all"
            >
              Weave Your First Story
            </Link>
          </div>
        )}
        {status === "error" && (
          <div data-testid="verify-error">
            <Moon size={36} className="text-purple-400 mx-auto mb-5" />
            <h2 className="font-serif text-2xl font-bold text-white mb-2">Link out of magic</h2>
            <p className="text-slate-400 text-sm mb-8">{message}</p>
            <Link
              to="/"
              className="inline-block px-8 py-3 rounded-full border border-purple-500/30 text-slate-300 font-medium text-sm hover:border-purple-400/60 transition-all"
            >
              Back to DreamWeaver
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}
